"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _mapInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/map");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getUserImageSuccess = exports.getUserImageAjax = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url"));

var _Observable = require("rxjs/Observable");

var _operators = require("rxjs/operators");

var _createAjaxEpic = require("../../../redux/createAjaxEpic");

var _UserActions = require("../../models/UserActions");

var _userApi = require("../userApi");

var _userRegistry = require("../userRegistry");

var getUserImageAjax = function getUserImageAjax(ajax, action) {
  var userId = action.payload || '';
  var userPhotoResponse = {
    userId: '',
    image: '',
    isUpdating: false,
    isComplete: false
  };
  return ajax.getJSON((0, _userApi.getMyImageUrl)(userId)).pipe((0, _mapInstanceProperty(_operators))(function (res) {
    userPhotoResponse.userId = userId;
    userPhotoResponse.image = _url.default.createObjectURL(res);
    return userPhotoResponse;
  })).pipe((0, _operators.catchError)(function (error) {
    return _Observable.Observable.of(error);
  }));
};

exports.getUserImageAjax = getUserImageAjax;

var getUserImageSuccess = function getUserImageSuccess(state, action) {
  if (action.payload === undefined) {
    return state;
  }

  var userImage = action.payload;
  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
    userImage: userImage
  });
};

exports.getUserImageSuccess = getUserImageSuccess;

_userRegistry.userRegistry.add((0, _createAjaxEpic.getSuccessActionType)(_UserActions.UserActions.getMyImageRequest), getUserImageSuccess);

(0, _createAjaxEpic.addAjaxEpic)(_userRegistry.userRegistry, _UserActions.UserActions.getMyImageRequest, getUserImageAjax, {
  showErrorAsToast: false
});